/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const validMap = ["admin", "editor"];
  return validMap.indexOf(str.trim()) >= 0;
}

/**
 * @param {String} str
 * @returns {Boolean}
 */
export function validMobile(str) {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(str);
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validPhone(phone) {
  const reg =
    /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
  return reg.test(phone);
}

/**
 * @param {string} url
 * @returns {Boolean}
 */
export function validURL(url) {
  const reg =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * @param {string} email
 * @returns {Boolean}
 */
export function validEmail(email) {
  // eslint-disable-next-line
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true;
  }
  return false;
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]";
  }
  return Array.isArray(arg);
}

/**
 * 判断是否是微信浏览器
 * @returns {Boolean}
 */
export function isMicroMessenger() {
  // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
  var ua = window.navigator.userAgent.toLowerCase();
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if (ua.match(/MicroMessenger/i) === "micromessenger") {
    return true;
  } else {
    return false;
  }
}

export function validCompanyIndustry(rule, value, cb) {
  if (value.length > 3) {
    cb(new Error("最多选三个"));
  } else if (value.length == 0) {
    cb(new Error("请选择所属行业"));
  } else {
    cb();
  }
}

export function validInvoicePhone(rule, value, cb) {
  const reg =
    /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/;
  if (reg.test(value)) {
    return cb();
  }
  cb(new Error("请输入正确的电话号"));
}

export function validInvoiceEmail(rule, value, cb) {
  // eslint-disable-next-line
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (reg.test(value)) {
    return cb();
  }
  cb(new Error("请输入正确的邮箱号"));
}
// ---------------------------------------------------------
// 验证手机号的规则(严谨，工信部2019年公布手机段) （非必填可为空）
export function checkSalesPersonPhone(rule, value, cb) {
  // const regSalesPersonPhone = /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
  const regSalesPersonPhone = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/;
  if (value) {
    if (regSalesPersonPhone.test(value)) {
      return cb();
    } else {
      cb(new Error("请输入正确的手机号"));
    }
  } else {
    cb();
  }
}

// 银行卡号的规则(10~30位，覆盖对公/私账户，参考微信支付) （非必填可为空）
export function checkInvoiceBankNo(rule, value, cb) {
  const regInvoiceBankNo = /^[1-9]\d{9,29}$/;
  if (value) {
    if (regInvoiceBankNo.test(value)) {
      return cb();
    } else {
      cb(new Error("请输入正确的银行卡号"));
    }
  } else {
    cb();
  }
}

// 订单有效期(正整数)
export function checkValidity(rule, value, cb) {
  const regValidity = /^\+?[1-9]\d*$/;
  if (regValidity.test(value)) {
    return cb();
  }
  cb(new Error("有效期需填写整数"));
}

// 纳税人识别号的规则(全数字或包含纳税人识别号规定大写字母)
export function checkInvoiceCode(rule, value, cb) {
  const regInvoiceCode = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  if (regInvoiceCode.test(value)) {
    return cb();
  }
  cb(new Error("请输入正确的纳税人识别号"));
}

// 验证金额的规则(只支持校验正数，不支持校验千分位分隔符)
export function checkInvoiceAmount(rule, value, cb) {
  const regInvoiceAmount =
    /(?:^[1-9]([0-9]+)?(?:\.[0-9]{1,2})?$)|(?:^(?:0)$)|(?:^[0-9]\.[0-9](?:[0-9])?$)/;
  if (regInvoiceAmount.test(value)) {
    return cb();
  }
  cb(new Error("金额大于0且最多为两位小数"));
}

// 税率校验(0~100)
export function checkRate(rule, value, cb) {
  const regInvoiceAmount =
    /^(?:(?!0\d)\d{1,2}(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/;
  if (regInvoiceAmount.test(value)) {
    return cb();
  }
  cb(new Error("税率应在0~100之间且最多为两位小数"));
}
// 社会信用代码
export function checkUnifiedCreditCode(rule, value, cb) {
  // const regInvoiceCode = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  const regInvoiceCode = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/;
  if (regInvoiceCode.test(value)) {
    return cb();
  }
  cb(new Error("请输入正确的统一信用代码"));
}

export function checkCode(rule, value, cb) {
  // const regInvoiceCode = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
  const regInvoiceCode =
    /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/;
  if (regInvoiceCode.test(value)) {
    return cb();
  }
  cb(new Error("格式错误，长度为15、17、18或20位的大写字母和数字组合"));
}
